import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="footer container">
      <p className="footer_paragraph">
        © 2025 | Design & Develop by
        <a
          className="footer_linkedIn"
          href="https://github.com/MichaelaKrakowka"
          target="_blank"
          rel="noopener noreferrer">
          Michaela Krakówka
        </a>
      </p>
    </footer>
  );
};
